module.exports = __webpack_public_path__ + "static/media/food-chains-in-peril_desktop.801d8c60.jpg";